<template>
    <v-app :style="`background: url(${require('@/assets/img/background.png')});
    background-size: cover;
     background-repeat-x: no-repeat;
      background-repeat-y: repeat;
      background-attachment: fixed;`">
        <Main></Main>
        <Snackbar ref="snackbar"
                  :text="snackbarMessage"></Snackbar>
        <div class="app-version">{{appVersion}}</div>
    </v-app>
</template>

<script>
    import {components} from 'aws-amplify-vue'
    import Main from "./layout/Main";
    import Snackbar from "./components/Snackbar";
    import {AmplifyEventBus} from 'aws-amplify-vue';
    import {store} from './store/store'
    import pjson from '../package.json'
    import Amplify from "aws-amplify";
    import axios from "axios"

    export default {
        name: 'App',
        components: {
            components,
            Main,
            Snackbar
        },
        data: () => ({
            snackbarMessage: 'Verify your email address to start using application.',
            appVersion: null
        }),
        mounted() {
            axios.get(`/iam/v1/cognito_config/VueApp`)
            .then(resp => {
              console.log(resp);
              var client = resp.data.clients[0];
              Amplify.configure({
                Auth: {
                  region: client.ClientId,
                  userPoolId: client.UserPoolId,
                  userPoolWebClientId: client.ClientId,
                }});
            }).catch(err => {
              alert("Could not load identity provider application configuration. Please contact your support");
              console.log(err);
            });
            AmplifyEventBus.$on('authState', this.authenticationManage);
            this.appVersion = pjson.version;
        },
        methods: {
            authenticationManage: function ($e) {
                if ($e === 'signUp') {
                    this.$router.push({name: 'Register'})
                } else if ($e === 'confirmSignUp') {
                    this.$router.push({name: 'Login'});
                    this.$refs.snackbar.openSnackbar();
                } else if ($e === 'forgotPassword') {
                    this.$router.push({name: 'Reset password'})
                } else if ($e === 'signIn') {
                    this.$router.push({name: 'Login'})
                } else if ($e === 'signedIn') {
                    this.$router.push({name: 'Community'});
                } else if ($e === 'signedOut') {
                    store.commit('setAWSToken', null);
                    this.$router.push({name: 'Login'})
                }
            },
        }
    };
</script>

<style>
.hoverlayer .hovertext path, rect {
  fill-opacity: 1;
}
</style>
